/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/performances-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/performances-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/performances-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-performances-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/performances.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.819Z
 * Source config: config/entities/performances-entity-config.ts
 * Public fields: 11/23 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PerformancesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  performance_name: Type.Union([Type.String(), Type.Null()]), // performance_name field
  start_datetime: Type.Union([Type.String(), Type.Null()]), // start_datetime field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  is_slack: Type.Union([Type.Boolean(), Type.Null()]), // is_slack field
  round_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // round_id field
  is_published: Type.Union([Type.Boolean(), Type.Null()]), // is_published field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
});

export const CreatePerformancesSchema = Type.Object({
  performance_name: Type.Union([Type.String(), Type.Null()]), // performance_name field
  start_datetime: Type.Union([Type.String(), Type.Null()]), // start_datetime field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  is_slack: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_slack field
  round_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // round_id field
  is_published: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_published field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
});

export const UpdatePerformancesSchema = Type.Object({
  performance_name: Type.Union([Type.String(), Type.Null()]), // performance_name field
  start_datetime: Type.Union([Type.String(), Type.Null()]), // start_datetime field
  max_contestants: Type.Union([Type.Number(), Type.Null()]), // max_contestants field
  is_slack: Type.Union([Type.Boolean(), Type.Null()]), // is_slack field
  round_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // round_id field
  is_published: Type.Union([Type.Boolean(), Type.Null()]), // is_published field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PerformancesRow = Static<typeof PerformancesSchema>;
export type PerformancesInsert = Static<typeof CreatePerformancesSchema>;
export type PerformancesUpdate = Static<typeof UpdatePerformancesSchema>;

// Legacy type aliases for backward compatibility
export type Performances = PerformancesRow;
export type CreatePerformances = PerformancesInsert;
export type UpdatePerformances = Static<typeof UpdatePerformancesSchema>;

// Field configuration metadata
export const PerformancesFieldConfig = {
  filterable: ['id', 'round_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
